import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const PostListItemRow = ({
   addedBy,
   dateAdded,
   name,
   slug
}) => (
   <Link to={`/initiatives/${slug}`}>
      <View
         display="flex"
         padding="15px 0px"
         borderTop="1px solid #ddd">
         <View flex="0 0 auto" width="120px[a-b] 150px[c-f]" padding="0 6px">
            <Text
               size="0.9"
               weight="medium"
               color="#666"
               transform="uppercase">
               {dateAdded}
            </Text>
         </View>
         <View>
            <Text size="2" color="#111" weight="medium">
               {name}
            </Text>
            <View width="100%" height="3px" />
            <Text size="1.5" color="#666">
               Posted by
               &nbsp;
               <b>{addedBy.fullName}</b>
            </Text>
         </View>
      </View>
   </Link>
)

PostListItemRow.propTypes = {
   addedBy: PropTypes.shape({
      fullName: PropTypes.string.isRequired
   }).isRequired,
   dateAdded: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   slug: PropTypes.string.isRequired
}

export default PostListItemRow
